import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Build the component.
const ScrollToTop = () => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return null
}

// Export the component for use.
export default ScrollToTop
